/* esm.sh - @radix-ui/react-label@2.1.8 */
export * from "/*@radix-ui/react-label@2.1.8/esnext/react-label.mjs";
